export namespace NearbySchoolsActions {
	export class GetNearbySchools {
		static readonly type = '[NearbySchools] Get Nearby Schools';
		constructor(
			public lat: number,
			public lng: number
		) {}
	}

	export class SelectNearbySchool {
		static readonly type = '[NearbySchools] Select Nearby School';
		constructor(public schoolID: number) {}
	}
}
